import { get, post } from '@/plugins/axios.js'

// 如果我们的项目需要代理多个地址，就不能在axios中设置 axios.defaults.baseURL
// 应该在此处动态的拼接url！
const baseApi = process.env.VUE_APP_BASE_API
const hyitf = process.env.VUE_APP_HYITF

const home = {
    /**
                       * 获取天气摘要数据
                       * @returns
                       */
    getGZ_analysisAndNews () {
        return get(`${baseApi}/data/analysisAndNews/gz_analysisAndNews.json`)
    },

    /**
                       * 获取景点天气数据
                       * @returns
                       */
    getGZ_travelIntroduce () {
        return get(`${baseApi}/data/gz_travelIntroduce.json`)
    },

    /**
                       * 获取短时天气数据
                       * @returns
                       */
    getGZ_shortTime () {
        return get(`${baseApi}/data/shorttime/gz_shorttime.json`)
    },

    /**
                       * 获取空气质量数据
                       * @returns
                       */
    getGZ_airQuality () {
        return get(`${baseApi}/data/gzWeather/gz_aqi.json`)
    },

    /**
                       * 获取天气预警
                       * @returns
                       */
    getGZ_areaAlarm () {
        return get(`${baseApi}/data/alarm/gz_areaAlarm.json`)
    },

    /**
                       * 获取生活指数
                       * @returns
                       */
    getGZ_livingPercent () {
        return get(`${baseApi}/data/gzWeather/livingIndex.json`)
    },

    /**
                       * 获取周边城市的天气情况
                       * @returns
                       */
    getAroundCityWeather () {
        const random = Math.random()
        return get(`${baseApi}/data/gzWeather/provinceCityForecast.json?random=${random}`)
    },

    /**
                       * 获取五战一场所需的天气信息
                       * @returns
                       */
    getGZ_trafficSpotsWeather () {
        return get(`${baseApi}/data/gzWeather/obtData.json`)
    },

    getGiftDailyCache (name) {
        return get(`${baseApi}/data/giftDailyCache/${name}.json`)
    },

    /**
                       * 获取五站一台数据
                       * @param {*} name
                       * @returns
                       */
    getGZ_scenicSpotsWeather (name) {
        const random = Math.random()
        return get(`${baseApi}/data/giftDailyCache/${name}.json?random=${random}`)
    },

    /**
     * 获取七天天气预报信息
     * @returns
     */
    getGZ_weatherForecastByDays () {
        return get(`${baseApi}/data/weatherForecastByDays/gz_weatherForecastByDays.json?random=${Math.random()}`)
    }

}

export default home
